import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import './styles/index.scss';

import AppRouting from './routes/AppRouting';
import _error from './pages/_error';
import GlobalFooter from '../src/components/organisms/GlobalFooter';
import GlobalHeader from '../src/components/organisms/GlobalHeader';
import GlobalHead from '../src/components/organisms/GlobalHead';
import Login from '../src/pages/index.jsx';
import EmployeeRedirect from '../src/pages/EmployeeRedirect';
import FooterTOU from '../src/pages/FooterTOU';
import LoginAssistant from '../src/pages/LoginAssistant';
import DocumentViewerPage from '../src/pages/documentViewer';
import LandingPage from '../src/pages/landing-page/landingPage';
import RedirectLandingPage from '../src/pages/landing-page/redirectLandingPage';
import FindByRequirementId from '../src/pages/landing-page/FindByRequirementId';
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { USBGrid, USBColumn } from '@usb-shield/components-react';

import DocContextProvider from './pages/context/DocContext';
import DashboardContextProvider from './pages/context/DashboardContext';
import PermissionRoleContextProvider from './components/Hooks/usePermissionRoles';
import FeatureFlagsContextProvider from './components/Hooks/useFeatureFlags';
import ConfigConstantsContextProvider from './components/Hooks/useConfigConstants';
import CBDownloadsContextProvider from './pages/context/CBDownloadsContext';
import IBDownloadsContextProvider from './components/Hooks/useDownloadStatusInbox';
import FeatureCategoryContextProvider from './components/Hooks/useFeatureCategories';
import Layout from '../src/components/Layout/Layout';
import DocumentTemplate from '../src/pages/DocumentTemplate';
import Employee from './pages/Employee';
import Termsofuse from '../src/pages/Termsofuse';
import GlobalSearch from './pages/Reports/LookupSearch';
import Notifications from '../src/pages/Notifications';
import ReportingDashboard from '../src/pages/ReportingDashboard';
import CBPortfolioParent from '../src/pages/ClosingBinderPortfolio/CBPortfolioParent';
import Inbox from '../src/pages/Inbox/Inbox';
import Requirements from '../src/pages/Requirements/Requirements'
import InboxDetails from '../src/pages/Inbox/InboxDetails';
import InboxRequirement from './pages/RequirementDetails/InboxRequirement';
import ClosingBinders from '../src/pages/RequirementDetails/ClosingBinders';
import CBDoctypeReport from '../src/pages/RequirementDetails/CBDoctypeReport';
import FeatureFlags from '../src/pages/RequirementDetails/FeatureFlags';
import CBFileNettypeReport from '../src/pages/RequirementDetails/CBFileNettypeReport';
import RequirementDetails from '../src/pages/RequirementDetails';
import Reports from '../src/pages/Reports';
import PSAReports from '../src/pages/Reports/PSA report';
import VendorCompanyFilter from './pages/Reports/VendorAccessReport';
import VendorUserFilter from './pages/Reports/VendorUserReport';
import CompanyAccessReport from './pages/Reports/CustomerAccessReport';
import EnrollmentReport from './pages/Reports/EnrollmentReport';
import CategoryConfig from './pages/CatergoryConfig/categoryConfig';
import '@usb-shield/components-react/dist/styles/shield.css';
import './pages/index.css';
import './pages/external.scss';

import '@usb-shield/themes/dist/styles/shield.css';
import '@usb-shield/react-calendar/dist/library/styles/index.css';
import '@usb-shield/react-date-picker/dist/library/styles/index.css';
import './components/utilities/UsbTable.css';

import logo from './assets/images/usbank.png';
import { setUserRole } from '../src/components/utilities/Utils';
import RedirectManageUser from './pages/manage-user/RedirectManageUser';
import Scans from './pages/Scans';
import Contacts from './pages/Contacts/Contacts';

const App = () => {
  const basePath = process.env.BASE_PATH;
  const updateRedirectUrl = () => {
    if (
      window.location.pathname === '/' ||
      window.location.pathname === '/LoginAssistant' ||
      window.location.pathname === '/Employee' ||
      window.location.pathname === '/EmployeeRedirect' ||
      window.location.pathname === '/Termsofuse' ||
      window.location.pathname === '/FooterTOU' ||
      window.location.pathname === '/Error'
    ) {
    } else {
      if (!sessionStorage.getItem('tok')) {
        localStorage.setItem('redirectURL', window.location.href);
        const currentUrl =
          typeof window !== 'undefined' ? window.location.href : '';
        if (currentUrl.includes('dns.com')) {
          window.location.href = '/Employee';
        } else {
          window.location.href = '/';
        }
      } else {
        if (localStorage.getItem('redirectURL')) {
          let url = localStorage.getItem('redirectURL')
          if(!url.toLowerCase().includes("route=manage") || !url.toLowerCase().includes("manageuser")){
            window.location.href = localStorage.getItem('redirectURL');
            localStorage.removeItem('redirectURL');
          }
        }
      }
    }
  };

  useEffect(() => {
    updateRedirectUrl();
  }, []);

  useEffect(() => {
    if (!sessionStorage.getItem('userrole')) {
      setUserRole();
    }
  }, []);

  useEffect(() => {
    window.process = {
      ...window.process,
      env: {
        LOG_LEVEL: 'info',
      },
    };
  }, []);

  if ((window.location.pathname).toLocaleLowerCase() === '/welcome') {
    return (
      <DocContextProvider>
        <DashboardContextProvider>
          <ConfigConstantsContextProvider>
            <PermissionRoleContextProvider>
              <FeatureFlagsContextProvider>
                <FeatureCategoryContextProvider>
                  <LandingPage />
                </FeatureCategoryContextProvider>
              </FeatureFlagsContextProvider>
            </PermissionRoleContextProvider>
          </ConfigConstantsContextProvider>
        </DashboardContextProvider>
      </DocContextProvider>
    );
  }

  if (
    window.location.pathname === '/' ||
    window.location.pathname === '/LoginAssistant' ||
    window.location.pathname === '/Employee' ||
    window.location.pathname === '/EmployeeRedirect' ||
    window.location.pathname === '/Termsofuse' ||
    window.location.pathname === '/FooterTOU' ||
    window.location.pathname === '/Error'
  ) {
    return (
      <DocContextProvider>
        <DashboardContextProvider>
          <GlobalHead title="U.S. Bancorp Impact Finance - USBANK" />
          <USBGrid addClasses="blue-frame top-menu">
            <USBColumn largeSpan={2} />
            <USBColumn largeSpan={12}>
              <ul>
                <li>
                  <div className="usb-logo">
                    <img src={logo}></img>
                  </div>
                </li>
              </ul>
            </USBColumn>
            <USBColumn largeSpan={2} />
          </USBGrid>

          <Router>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/LoginAssistant" element={<LoginAssistant />} />
              <Route path="/Employee" element={<Employee />} />
              <Route path="/EmployeeRedirect" element={<EmployeeRedirect />} />
              <Route path="/Termsofuse" element={<Termsofuse />} />
              <Route path="/FooterTOU" element={<FooterTOU />} />
              <Route path="/Error" element={<_error />} />
            </Routes>
          </Router>

          <GlobalFooter />
        </DashboardContextProvider>
      </DocContextProvider>
    );
  }

  return (
    <DocContextProvider>
      <DashboardContextProvider>
        <PermissionRoleContextProvider>
          <ConfigConstantsContextProvider>
            <FeatureFlagsContextProvider>
              <CBDownloadsContextProvider>
                <IBDownloadsContextProvider>
                  <FeatureCategoryContextProvider>
                    <Router>
                      <Routes>
                        <Route path="/" element={
                          <>
                            <GlobalHead title="U.S. Bancorp Impact Finance - USBANK" />
                            <USBGrid addClasses="blue-frame top-menu">
                              <USBColumn largeSpan={2} />
                              <USBColumn largeSpan={12}>
                                <ul>
                                  <li>
                                    <div className="usb-logo">
                                      <img src={logo}></img>
                                    </div>
                                  </li>
                                </ul>
                              </USBColumn>
                              <USBColumn largeSpan={2} />
                            </USBGrid>
                            <Login />
                            <GlobalFooter />
                          </>
                        } />

                        <Route path="/Redirect" element={<RedirectLandingPage />} />

                        <Route path="/FindByRequirementId" element={<Layout><FindByRequirementId /></Layout>} />
                        <Route path="/DocumentTemplate" element={<Layout><DocumentTemplate /></Layout>} />
                        <Route path="/Reports/PortalSubmission" element={<Layout><Reports /></Layout>} />
                        <Route path="/Reports/Lookup" element={<Layout><GlobalSearch /></Layout>} />
                        <Route path="/Reports/PSAFilter" element={<Layout><PSAReports /></Layout>} />
                        <Route path="/Reports/VendorCompanyFilter" element={<Layout><VendorCompanyFilter /></Layout>} />
                        <Route path="/Reports/VendorUserFilter" element={<Layout><VendorUserFilter /></Layout>} />
                        <Route path="/Reports/CustomerAccessFilter" element={<Layout><CompanyAccessReport /></Layout>} />
                        <Route path="/Reports/enrollmentReport" element={<Layout><EnrollmentReport /></Layout>} />

                        <Route path="/ManageUser/*" element={<Layout><AppRouting /></Layout>} />
                        <Route path="/CategoryConfig" element={<Layout><CategoryConfig /></Layout>} />
                        <Route path="/ClosingBinders/Portfolio" element={<Layout><CBPortfolioParent /></Layout>} />
                        <Route path="/Inbox" element={<Layout><Inbox /></Layout>} />
                        <Route path="/AllRequirements" element={<Layout><Requirements /></Layout>} />
                        <Route path="/Inbox/:id" element={<Layout><InboxDetails /></Layout>} />
                        <Route path="/ClosingBinders/Portfolio/Requirements" element={<Layout><ClosingBinders /></Layout>} />
                        <Route path="/Inbox/Portfolio/Requirements" element={<Layout><InboxRequirement /></Layout>} />
                        <Route path="/ClosingBinders/Doctype" element={<Layout><CBDoctypeReport /></Layout>} />
                        <Route path="/FeatureFlags" element={<Layout><FeatureFlags /></Layout>} />
                        <Route path="/FeatureByCategory" element={<Layout><CategoryConfig /></Layout>} />
                        <Route path="/Scans" element={<Layout><Scans /></Layout>} />
                        <Route path="/Contacts" element={<Layout><Contacts /></Layout>} />
                        <Route path="/ClosingBinders/FileNettype" element={<Layout><CBFileNettypeReport /></Layout>} />
                        <Route path="/MyProfile" element={<Layout><Navigate to="/ManageUser/my-profile" replace /></Layout>} />
                        <Route path="/Notifications" element={<Layout><Notifications /></Layout>} />
                        <Route path="/ReportingDashboard" element={<Layout><ReportingDashboard /></Layout>} />
                        <Route path="/RequirementDetails" element={<Layout><RequirementDetails /></Layout>} />
                        <Route path="/document-viewer" element={<Layout><DocumentViewerPage /></Layout>} />
                        <Route path="/RedirectManageUser" element={<Layout><RedirectManageUser /></Layout>} />
                      </Routes>
                    </Router>
                  </FeatureCategoryContextProvider>
                </IBDownloadsContextProvider>
              </CBDownloadsContextProvider>
            </FeatureFlagsContextProvider>
          </ConfigConstantsContextProvider>
        </PermissionRoleContextProvider>
      </DashboardContextProvider>
    </DocContextProvider>
  );
};

// App.propTypes = {
//   Component: PropTypes.node.isRequired,
//   // eslint-disable-next-line react/forbid-prop-types
//   pageProps: PropTypes.object,
//   router: PropTypes.shape({
//     pathname: PropTypes.string
//   }),
// }

// App.defaultProps = {
//   pageProps: undefined,
//   router: undefined
// }

export default App;